module.exports = __webpack_public_path__ + "img/selected3-min.551c7ec6.png";